var CVTranslator = require("bazinga-translator");

class VisitorsInformation {
    constructor(addGuestButtonSel, sendButtonSel, prototypeSel, panelHolderSel, panelSel, guestLabel, clearLabel, copyAddressLabel, formPrototype, maxGuests, defaultTitle, styleStickyTop) {
        this.addGuestButtonEl = $(addGuestButtonSel);
        this.sendButtonEl = $(sendButtonSel);
        this.prototypeEl = $(prototypeSel);
        this.panelSel = panelSel;
        this.panelHolderEl = $(panelHolderSel);
        this.formPrototypeEl = formPrototype;
        this.maxGuests = maxGuests;
        this.guestLabel = guestLabel;
        this.clearLabel = clearLabel;
        this.copyAddressLabel = copyAddressLabel;
        this.defaultTitle = defaultTitle;
        this.styleStickyTop = styleStickyTop;
        this.setupEvents();

    }

    setupEvents() {
        this.addGuestButtonEl.on('click', (e) => {
            e.preventDefault();
            if (this.maxGuestsReached()) {
                this.addGuestButtonEl.prop('disabled', 'disabled');
                return;
            } else {
                var size = $(this.panelSel).size();
                var formProto = this.formPrototypeEl.replace(/__name__/g, size ).replace(/__nameid__/g, size );
                var proto = this.prototypeEl.html().replace(/__name__/g, size + 1).replace(/__nameid__/g, size ).replace(/__guestLabel__/g, guestLabel).replace(/__formPrototype__/g, formProto).replace(/__clearLabel__/g, clearLabel).replace(/__defaultTitle__/g, this.defaultTitle).replace(/__copyAddressLabel__/g, copyAddressLabel).replace(/__styleStickyTop__/g, this.styleStickyTop);
                this.panelHolderEl.append(proto);
                $('[data-toggle="tooltip"]').tooltip();
                $('[data-toggle="popover"]').popover();
                if  (typeof window !== "undefined") {
                    window['cvrm_visitors_information_visitorsInformation_' + size] = new window.CvrmVisitorInformation(
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_firstName',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_surname',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_nationality',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_surname2',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_gender',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_docType',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_birthdate',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_docDate',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_docNum',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_email',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_phoneNumber',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_address',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_address2',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_city',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_province',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_municipality',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_postalCode',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_country',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_supportNumberEsId',
                        '#cvrm_visitors_information_visitorsInformation_'+size+'_relationship'
                    );
                    window['cvrm_visitors_information_visitorsInformation_' + size].setupEvents();
                    window.setupSelects(size);
                 }
            }
        });
        this.checkOneFilled();
        $('#send-visitors').on('click', function () {
            if ($('#data-correct').prop('checked') === true) {
                return true;
            } else {
                $('#data-correct-label').parent().addClass('has-error');
                $('#data-correct-label').addClass('underline');
                $('#data-correct-label').css({'font-weight':'600'});
                bootbox.alert(CVTranslator.trans('visitorsinfo.confirm', {}, 'messages'));
                return false;
            }
        });
        $('#save-visitors').on('click', function (event) {
            // prevent default action
            event.preventDefault();
            clickedButton = this;
            let message = CVTranslator.trans('visitorinfo.save_confirm', {}, 'messages');
            bootbox.confirm({
                message: message,
                callback: function (result) {
                    if (result) {
                         // create a hidden input with the clicked button's name/value
                        const name = $(event.target).attr("name");
                        const value = $(event.target).val();

                        if (name && value) {
                            const form = document.forms['cvrm_visitors_information']; // access form by name

                            // Create a hidden input to mimic clicked button
                            const hidden = document.createElement("input");
                            hidden.type = "hidden";
                            hidden.name = clickedButton.name;
                            hidden.value = clickedButton.value;
                            hidden.classList.add("temp-submit");

                            // Remove any previous temp buttons (just in case)
                            const existing = form.querySelectorAll(".temp-submit");
                            existing.forEach(e => e.remove());

                            form.appendChild(hidden);
                            form.submit();
                        }
                        return true;
                    }
                }
            });
        });
    }
    maxGuestsReached() {
         if ($(this.panelHolderEl).children().length >= this.maxGuests) {
             return true;
         }
         return false;
    }
    checkAllFilled() {
        var allFilled = true;
        $(this.panelSel).each((idx, el) => {
            if (!$(el).find('.card-body').hasClass('completed')) {
                allFilled = false;
            } 
        });
        if (allFilled) {
            $(this.sendButtonEl).prop('disabled', false);
        } else {
            $(this.sendButtonEl).prop('disabled', true);
        }

    }

    checkOneFilled() {
        var oneFilled = false;
        var onePartlyFilled = false;
        $(this.panelSel).each((idx, el) => {
            if ($(el).find('.card-body').hasClass('completed')) {
                oneFilled = true;
            }
            if ($(el).hasClass('incomplete')) {
                onePartlyFilled = true;
            }
        });
        if (oneFilled && !onePartlyFilled) {
            $(this.sendButtonEl).prop('disabled', false);
        } else {
            $(this.sendButtonEl).prop('disabled', true);
        }
    }
}

module.exports = VisitorsInformation;
